import adressFullStringGetter from '@/services/general/adressFullStringGetter';

export function constructInformationLigneTournee(patrimonialFace, ligne, reseauInformation) {
  ligne.dispositif = patrimonialFace.materiel.dispositif.dispositifType ? patrimonialFace.materiel.dispositif.dispositifType.id : '';
  ligne.dispositifLibelle = patrimonialFace.materiel.dispositif.dispositifType ? patrimonialFace.materiel.dispositif.dispositifType.libelle : '';
  ligne.materiel = patrimonialFace.materiel.type ? patrimonialFace.materiel.type.id : '';
  ligne.materielLibelle = patrimonialFace.materiel.type ? patrimonialFace.materiel.type.libelle : '';
  ligne.face = patrimonialFace.code;
  ligne.etat = patrimonialFace.etat;
  ligne.format = patrimonialFace.materiel.format ? patrimonialFace.materiel.format.id : '';
  ligne.formatLibelle = patrimonialFace.materiel.format ? patrimonialFace.materiel.format.libelle : '';
  ligne.cp = patrimonialFace.materiel.dispositif.adresse.codePostal;
  ligne.ville = patrimonialFace.materiel.dispositif.adresse.ville;
  ligne.selected = false;
  ligne.adresse = adressFullStringGetter(patrimonialFace.materiel.dispositif.adresse, true);
  ligne.commercialisable = !patrimonialFace.faceMotifNonComId;
  ligne.reseau = '';
  ligne.emplacementLibelle = patrimonialFace.materiel.dispositif.emplacement.code;
  ligne.disposition = patrimonialFace.materiel.disposition;
  if (reseauInformation && reseauInformation.length > 0) {
    reseauInformation.forEach((reseau, index) => {
      ligne.reseau += reseau.libelle;
      if (index + 1 !== reseauInformation.length) {
        ligne.reseau += ', ';
      }
    });
  }
}

export function addInformationsOfFacesInLignes(allPatrimonialFaceInformation,
  allTourneeLignes, reseauInformation) {
  allTourneeLignes.forEach((ligne) => {
    const patrimonialFace = allPatrimonialFaceInformation.find((face) => {
      return face.id === ligne.faceId;
    });
    constructInformationLigneTournee(patrimonialFace, ligne,
      reseauInformation[patrimonialFace.produitId]);
  });
}
